import { ContentCardProps } from "@omni/types/components/props/contentCard.props";
import { Card } from "@omni/ui/components/Card/card";
import { card } from "@omni/ui/components/Card/card.style";
import { cn } from "@omni/utils/styles";

import * as ResponsiveImageHelper from "@/components/General/Image/helpers/responsiveImage.helpers";

import { Image } from "../Image/image";
import { contentCard } from "./contentCard.styles";

const ContentCard = ({
    link,
    title,
    linkText,
    description,
    responsiveImage
}: ContentCardProps) => {
    const TitleTag = title?.element || "h3";

    const imageProps = responsiveImage
        ? ResponsiveImageHelper.toImageProps({
              image: responsiveImage
          })
        : undefined;

    const { image } = card();
    const { base, image: contentCardImage } = contentCard();

    return (
        <Card
            tag="a"
            border={false}
            className={base()}
            href={link}
        >
            {imageProps && (
                <Image {...imageProps}>
                    <Image.Img
                        className={contentCardImage({
                            className: image({
                                className: "tw:aspect-4/3!",
                                imgAlignment: "top",
                                border: false
                            })
                        })}
                    />
                </Image>
            )}

            <Card.Body className={cn("tw:px-0! tw:py-1! tw:grow")}>
                {title && (
                    <Card.Title
                        tag={TitleTag}
                        className={cn("tw:text-primary")}
                    >
                        {title?.text}
                    </Card.Title>
                )}
                {description && (
                    <Card.Text
                        dangerouslySetInnerHTML={{ __html: description }}
                    ></Card.Text>
                )}
            </Card.Body>
            {linkText && (
                <Card.Footer className={cn("tw:px-0! tw:py-1!")}>
                    <Card.Link
                        className={cn("tw:my-2")}
                        color={"gray"}
                    >
                        {linkText}
                        <i
                            className={cn(
                                "las la-lg la-angle-right tw:ml-2 tw:self-center"
                            )}
                        ></i>
                    </Card.Link>
                </Card.Footer>
            )}
        </Card>
    );
};

export { ContentCard };
